// Малките клетки на решетката „Доставка" (DeliveryWorksheetTable): заглавната
// клетка и обвивките на плоското поле и на „тежката" клетка (видът на
// затворената „тежка" клетка е `pickCellClassOf` в deliveryWorksheetShared).
// Височините са общите на работния лист (`components/list/density.ts` — SHEET_*).
import type { ReactNode } from "react";
import { SHEET_HEADER_CELL } from "../../components/list/density";

export function Th({
  children,
  center,
  right,
}: {
  children?: ReactNode;
  center?: boolean;
  right?: boolean;
}) {
  return (
    <div
      className={`${SHEET_HEADER_CELL} border-r border-shade-2 ${
        center ? "!px-2 justify-center text-center" : right ? "justify-end text-right" : "justify-start text-left"
      }`}
    >
      <span className="truncate">{children}</span>
    </div>
  );
}

// Като CellBox в оригинала: block обвивка с padding 2 — полето вътре опира
// почти от край до край, а колонният бордюр е на самата клетка.
export function CellBox({ children }: { children: ReactNode }) {
  return <div className="border-r border-shade-2 p-[2px]">{children}</div>;
}

// Обвивка на „тежка" клетка (Select/DatePicker) — колонният бордюр е тук, а
// смяната клетка ↔ редактор е в общия PickCell.
export function PickBox({ children }: { children: ReactNode }) {
  return <div className="flex min-w-0 items-stretch border-r border-shade-2 p-[2px]">{children}</div>;
}
